import type { TimelineHour } from "../../api/types";
import { cn } from "../../lib/cn";
import {
  SPARKLINE_PLOT_HEIGHT,
  SPARKLINE_PLOT_WIDTH,
  dayWindPeaks,
  formatWindSummary,
  gustSparklineSegments,
  hasGustSparkline,
  scaleMaxForDay,
  shouldShowWindSparkline,
  sparklinePoints,
  sustainedMph,
} from "../../lib/windSparkline";

interface Props {
  hours: TimelineHour[];
  className?: string;
}

export default function WindSparklineRow({ hours, className }: Props) {
  if (!shouldShowWindSparkline(hours)) {
    return null;
  }

  const peaks = dayWindPeaks(hours);
  const scaleMax = scaleMaxForDay(hours);
  const sustainedPoints = sparklinePoints(hours, sustainedMph, scaleMax);
  const gustSegments = gustSparklineSegments(hours, scaleMax);
  const showGustLine = hasGustSparkline(hours);

  return (
    <div className={cn("flex flex-col gap-1", className)} aria-hidden>
      <svg
        className="h-[12px] w-full"
        viewBox={`0 0 ${SPARKLINE_PLOT_WIDTH} ${SPARKLINE_PLOT_HEIGHT}`}
        preserveAspectRatio="none"
      >
        <polyline
          fill="none"
          points={sustainedPoints}
          stroke="var(--tc-color-on-surface-variant)"
          strokeOpacity={0.65}
          strokeWidth={1}
          vectorEffect="non-scaling-stroke"
        />
        {showGustLine
          ? gustSegments.map((points, index) => (
              <polyline
                key={index}
                fill="none"
                points={points}
                stroke="var(--color-weather-gust)"
                strokeDasharray="2 2"
                strokeOpacity={0.75}
                strokeWidth={1}
                vectorEffect="non-scaling-stroke"
              />
            ))
          : null}
      </svg>
      <p className="text-center text-[9px] text-on-surface-variant">{formatWindSummary(peaks)}</p>
    </div>
  );
}
